// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OpenActivity from './openActivity';
import React from 'react';

function OpenActivityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-open-activity-page">
            <OpenActivity />
        </AuthenticatedPage>
    );

}
OpenActivityPage.displayNAme = 'OpenActivityPage';

export default OpenActivityPage;
